import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import axios from 'axios';
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
Vue.use(ElementUI);
Vue.config.productionTip = false
import Viewer from 'v-viewer'
import 'viewerjs/dist/viewer.css'
import {get,post,put,del} from './common/http.js'; 
import url from './common/serveice.js'; 
console.log(url.url)
Vue.prototype.webUrl='https://img.qljkb.cn/'
Vue.prototype.upImg=url.url
Vue.prototype.httpGet=get
Vue.prototype.httpPost=post
Vue.prototype.httpPut=put
Vue.prototype.httpDel=del
import qs from 'qs';
Vue.prototype.$qs=qs

//验证手机号码
Vue.prototype.isTel=function (phone){
    let phoneCodeVerification = /^[1][3,4,5,7,8][0-9]{9}$/;
    return phoneCodeVerification.test(phone);
}
//验证是否为数字
Vue.prototype.isNum=function(nubmer) { 
　　var re = /^[0-9]+.?[0-9]*/;//判断字符串是否为数字//判断正整数/[1−9]+[0−9]∗]∗/ 　　 
	return re.test(nubmer)
}
Vue.prototype.isNullNum=function(nubmer) {
	if(nubmer==''){
		return true
	}
　　var re = /^[0-9]+.?[0-9]*/;//判断字符串是否为数字//判断正整数/[1−9]+[0−9]∗]∗/ 　　 
	return re.test(nubmer)
}

Vue.prototype.istwoNum=function(nubmer) {
	if(nubmer==''){
		return true
	}
　　var re =/(^[1-9](\d+)?(\.\d{1,2})?$)|(^\d\.\d{1,2}$)/;//判断大于0的整数或者保留两位小数
	return re.test(nubmer)
}












Vue.use(Viewer)
Viewer.setDefaults({
  Options: {
	"zIndex":999999999999,
    'inline': true,
    'button': true,
    'navbar': true,
    'title': true,
    'toolbar': true,
    'tooltip': true,
    'movable': true,
    'zoomable': true,
    'rotatable': true,
    'scalable': true,
    'transition': true,
    'fullscreen': true,
    'keyboard': true,
    'url': 'data-source'
  }
})
new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
